import React from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import FormComponent from './Form'
import { client } from '@utils/client'
import { useHistory } from 'react-router-dom'
import Modal from '@components/Modal'

const Edit = (props) => {
  const { setModalEditOpen, modalEditOpen, defaultValues } = props
  const { t } = useLocalization()
  const history = useHistory()
  // const params = useParams()

  const handleSubmit = async (data) => {
    let id = data.id
    delete data.id // ลบ ID เนื่องจาก Put ใช้ส่งทั้ง Form Backend ไม่รับ
    data.url = data.url || null
    setModalEditOpen(false)
    try {
      await client.put(`/activity/${id}`, data)
      message.success('สำเร็จ')
      history.push('/activities')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  return (
    <>
      <Modal
        centered={true}
        width={500}
        title={t('rewards.list.listScreen.edit')}
        open={modalEditOpen}
        onCancel={() => setModalEditOpen(false)}
        maskClosable={false}
        footer={null}
      >
        <FormComponent
          handleSubmit={handleSubmit}
          doStatus="edit"
          defaultValues={{
            ...defaultValues,
            posterImages: defaultValues.posterImages || [],
          }}
        />
      </Modal>
    </>
  )
}

Edit.propTypes = {
  defaultValues: PropTypes.object,
  setModalEditOpen: PropTypes.func,
  modalEditOpen: PropTypes.bool,
}

export default Edit
